import { ArrowLeft } from 'lucide-react';
import { Logo } from '../Logo';
import { Footer } from '../Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white">
      <nav className="sticky top-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <a href="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Back to Home</a>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-6 md:px-8 py-20">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit mb-2">Terms of Service</h1>
        <p className="text-sm text-zinc-500 mb-12">Last updated: March 28, 2026</p>

        <div className="space-y-8">
          <Section title="1. Acceptance of Terms">
            By accessing or using D3 Command (the "Service"), provided by D3 Global Holdings LLC ("Company"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.
          </Section>
          <Section title="2. Description of Service">
            D3 Command is an AI-powered operational governance platform that processes meeting recordings, extracts tasks, risks, and decisions, and provides real-time dashboards, analytics, notifications, and compliance tools.
          </Section>
          <Section title="3. Account Registration">
            You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your credentials and for all activity under your account. Notify us immediately of any unauthorized use.
          </Section>
          <Section title="4. Acceptable Use">
            You agree not to: upload content that is unlawful, harmful, or infringing; attempt to gain unauthorized access to any part of the Service; interfere with or disrupt the Service; use the Service for competing product development; or reverse-engineer any part of the platform.
          </Section>
          <Section title="5. Intellectual Property">
            The Service, including all software, designs, and content, is owned by D3 Global Holdings LLC. You retain ownership of your data. By using the Service, you grant us a limited license to process your data solely to provide the Service.
          </Section>
          <Section title="6. Data Processing">
            Meeting recordings you upload are processed by our AI pipeline to extract structured data. We do not use your data to train AI models for other customers. Your data is isolated within your organization's tenant.
          </Section>
          <Section title="7. Service Availability">
            We strive for high availability but do not guarantee uninterrupted service. We may perform maintenance with reasonable notice. The Service is provided "as is" without warranties of any kind.
          </Section>
          <Section title="8. Limitation of Liability">
            To the maximum extent permitted by law, D3 Global Holdings LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service. Our total liability shall not exceed the amount you paid for the Service in the 12 months preceding the claim.
          </Section>
          <Section title="9. Termination">
            Either party may terminate this agreement at any time. Upon termination, your access to the Service will cease. You may request export of your data within 30 days of termination.
          </Section>
          <Section title="10. Governing Law">
            These Terms are governed by the laws of the State of Texas, United States. Any disputes shall be resolved in the courts of Dallas County, Texas.
          </Section>
          <Section title="11. Contact">
            For questions about these Terms, contact us at:<br /><br />
            D3 Global Holdings LLC<br />
            2807 Allen St #2164, Dallas, TX 75204<br />
            Email: <a href="mailto:support@d3command.com" className="text-indigo-400 hover:text-indigo-300">support@d3command.com</a>
          </Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
      <p className="text-sm text-zinc-400 leading-relaxed">{children}</p>
    </div>
  );
}
